import { createFileRoute } from "@tanstack/react-router";
import heroAsset from "@/assets/foreclosure-hero.webp.asset.json";
import fcBefore from "@/assets/foreclosure-before.webp.asset.json";
import fcAfter from "@/assets/foreclosure-after.webp.asset.json";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/foreclosure-cleanouts")({
  head: () => ({
    meta: [
      { title: services["foreclosure-cleanouts"].metaTitle },
      { name: "description", content: services["foreclosure-cleanouts"].metaDescription },
      { property: "og:title", content: services["foreclosure-cleanouts"].metaTitle },
      { property: "og:description", content: services["foreclosure-cleanouts"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/foreclosure-cleanouts" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/foreclosure-cleanouts" }, { rel: "preload", as: "image", href: heroAsset.url, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Foreclosure Cleanouts', url: 'https://anchorsrq.com/foreclosure-cleanouts' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "foreclosure-cleanouts", name: 'Foreclosure Cleanouts', serviceType: 'Foreclosure Cleanout', description: 'Trusted REO and foreclosure cleanouts for banks, asset managers, and listing agents in the Sarasota region — broom-clean turnovers documented with before-and-after photos by Anchor Services.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["foreclosure-cleanouts"].faqs)) },
    ],
  }),
  component: () => (
    <ServicePage
      {...services["foreclosure-cleanouts"]}
      heroImg={heroAsset.url}
      beforeAfter={[
        {
          before: fcBefore.url,
          after: fcAfter.url,
          caption: "REO turnover in Sarasota — left-behind furniture, trash and debris removed and the home left broom-clean and listing-ready.",
        },
      ]}
    />
  ),
});
